import {BaseTimeUnit} from 'common/types/reports/bookmark';

export enum ArithmeticOperator {
  Datetime = `$datetime`,
  Defined = `defined`,
  Equals = `==`,
  EqualsAny = `equals_any`,
  GreaterThan = `>`,
  GreaterThanEquals = `>=`,
  In = `in`,
  LessThan = `<`,
  LessThanEquals = `<=`,
  NotDefined = `not defined`,
  NotEquals = `!=`,
  NotIn = `not in`,
}

export enum TypeCastOperator {
  Boolean = `boolean`,
  Datetime = `datetime`,
  List = `list`,
  Number = `number`,
  String = `string`,
}

export enum LogicalOperator {
  And = `and`,
  Not = `not`,
  Or = `or`,
}

export enum BehaviorCountType {
  Absolute = `absolute`,
  Day = `day`,
}

export const WindowUnit = BaseTimeUnit;
export type WindowUnit = BaseTimeUnit;

export enum PredefinedCohort {
  AllUsers = `$all_users`,
}

export enum Property {
  Behaviors = `behaviors`,
  Cohort = `cohort`,
  Event = `event`,
  Literal = `literal`,
  'PredefinedCohort' = `predefined_cohort`,
  'User' = `user`,
}
